import { useState } from 'react';
import PlayerRegistrationModal from '@/components/teams/PlayerRegistrationModal';

export const usePlayerRegistrations = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openRegistrationModal = () => {
    setIsModalOpen(true);
  };

  const closeRegistrationModal = () => {
    setIsModalOpen(false);
  };

  const PlayerRegistrationModalComponent = () => (
    <PlayerRegistrationModal
      isOpen={isModalOpen}
      onClose={closeRegistrationModal}
    />
  );

  return {
    openRegistrationModal,
    closeRegistrationModal,
    PlayerRegistrationModalComponent,
    isModalOpen
  };
};